<template>
  <div>
    <candidate-remove-warning
    :showModal="warningShow"
    @cancel="cancelRemove"
    @approve="removeUploadedFile"
    />
    <div class="upload">
      <div  class="upload__content">
        <div class="upload__content_left">
          <div class="upload__content_left-title">{{ resource["hrvenue.createcandidate.addCandidateTitle"] }}</div>
          <div class="upload__content_left-instruction">{{ resource["hrvenue.createcandidate.addCandidateInfoNew"].replace("{count}", sendableCount ?? 1000) }}</div>
          <div class="upload__content_left-example_file" v-html="exampleExcellText"></div>
        </div>
        <div class="upload__content_right">
          <template v-if="!isFileUploaded">
            <div class="upload__content_right-action">
              <input type="file" ref="myFile" id="myFile" name="myFile" @change="fileUpload" accept=".xlsx, .xls"
              class="d-none" />
              <button id="importFileBtn"  name="importFileBtn" class="border-button-detail-information"
              @click="() => { $refs.myFile.click(); gtmClickEvent(); }">
              <i><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12.0007 8.66659H8.66732V11.9999C8.66732 12.3666 8.36732 12.6666 8.00065 12.6666C7.63398 12.6666 7.33398 12.3666 7.33398 11.9999V8.66659H4.00065C3.63398 8.66659 3.33398 8.36659 3.33398 7.99992C3.33398 7.63325 3.63398 7.33325 4.00065 7.33325H7.33398V3.99992C7.33398 3.63325 7.63398 3.33325 8.00065 3.33325C8.36732 3.33325 8.66732 3.63325 8.66732 3.99992V7.33325H12.0007C12.3673 7.33325 12.6673 7.63325 12.6673 7.99992C12.6673 8.36659 12.3673 8.66659 12.0007 8.66659Z"
                    fill="#FF8D06" />
                </svg>
              </i>
              <span>{{ resource["hrvenue.createcandidate.attachWithExcel"] }}</span>
            </button>
            </div>
          </template>
          <div v-else class="upload__content_right-result">
            <div class="d-flex result-container">
              <span class="upload__file-icon">
                <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 16 16" width="16px" height="16px"><path fill="#b7dbba" d="M9.5 15.4L0.5 13.5 0.5 2.5 9.5 0.5z"/><path fill="#fff" d="M9.5 13.5h6v-11h-1-5V13.5zM5.1 8.6C5 8.5 5 8.4 5 8.3l0 0c0 .1-.1.3-.1.4l-1.1 2.2H2.4l1.7-3.2L2.5 5H4l.8 1.5C4.9 6.7 5 6.8 5 7l0 0c.1-.2.1-.3.2-.5L6 5h1.5L5.8 7.6l1.8 3.2H6.1L5.1 8.6z"/><path fill="#e0e9f0" d="M9.5 5H14V6H9.5zM9.5 7H14V8H9.5zM9.5 9H14V10H9.5zM9.5 11H14V12H9.5z"/><path fill="#5d9874" d="M16,2H9.2v1H15v10H9.2v1H16V2z"/><path fill="#5d9874" d="M10 15L9 15 9 13.4 10 14.4z"/><path fill="#5d9874" d="M10 16L0 13.9 0 2.1 10 0 10 12 9 12 9 1.2 1 2.9 1 13.1 9.6 14.9 9.6 15 10 15z"/><path fill="#5d9874" d="M10 14.4L10 12 9 12 9 13.4z"/></svg>
              </span>
              <div class="upload__content_right-result-info">
                <span class="upload__content_file--name">
                  {{ fileName }}
                </span>
                <div class="upload__content_file--size">
                  {{  fileSize }} KB
                </div>
              </div>
          </div>
            <span @click="warningShow=true" class="uploaded__file--icon">
              <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 14.25C5 15.075 5.675 15.75 6.5 15.75H12.5C13.325 15.75 14 15.075 14 14.25V5.25H5V14.25ZM7.3775 9.4425C7.085 9.15 7.085 8.6775 7.3775 8.385C7.67 8.0925 8.1425 8.0925 8.435 8.385L9.5 9.4425L10.5575 8.385C10.85 8.0925 11.3225 8.0925 11.615 8.385C11.9075 8.6775 11.9075 9.15 11.615 9.4425L10.5575 10.5L11.615 11.5575C11.9075 11.85 11.9075 12.3225 11.615 12.615C11.3225 12.9075 10.85 12.9075 10.5575 12.615L9.5 11.5575L8.4425 12.615C8.15 12.9075 7.6775 12.9075 7.385 12.615C7.0925 12.3225 7.0925 11.85 7.385 11.5575L8.4425 10.5L7.3775 9.4425ZM14 3H12.125L11.5925 2.4675C11.4575 2.3325 11.2625 2.25 11.0675 2.25H7.9325C7.7375 2.25 7.5425 2.3325 7.4075 2.4675L6.875 3H5C4.5875 3 4.25 3.3375 4.25 3.75C4.25 4.1625 4.5875 4.5 5 4.5H14C14.4125 4.5 14.75 4.1625 14.75 3.75C14.75 3.3375 14.4125 3 14 3Z" fill="#A9A9A9"/>
                </svg>
            </span>
          </div>
        </div>
      </div>
    </div>
    <p class="total-items pt-2 pb-2">
      <span class="bold">{{ candidate.candidates ? candidate.candidates.length : '' }}</span> {{ resource["hrvenue.createcandidate.totalCandidateText"] }}
    </p>
    <div class="list-group rectangle pt-1 pb-1">
      <b-row align-v="end" class="pl-3 pr-3 mt-3 ml-0 mr-0">
        <b-col col lg="3" class="p-0 mr-2">
          <span class="fw-500"> {{ resource['hrvenue.createCandidate.Name'] }}</span>
        </b-col>
        <b-col col lg="3" class="p-0">
          <span class="fw-500">{{ resource['hrvenue.createCandidate.Surname'] }}</span>
        </b-col>
        <b-col class="p-0">
          <span class="fw-500">{{ resource['hrvenue.createCandidate.Email'] }}</span>
        </b-col>
      </b-row>
      <div class="card-list-container">
        <interview-card-item v-for="(item, index) in getCandidates" :is-editable="isEditable" :is-delete="isEditable"
          :total-candidate-count="candidate.candidates.length" :key="index" :indexAt="index" :candidate="item"
          :order="index" @onDeleteQuestion="onDeleteQuestion" :invalid="invalid" @onCheckValidRule="onCheckValidRule" />
      </div>
      <div class="candidate-action-area" v-if="isEditable">
          <button id="createInterviewBtn" class="border-button-detail-information"
            @click="createNewInterViewer">
            <i><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.0007 8.66659H8.66732V11.9999C8.66732 12.3666 8.36732 12.6666 8.00065 12.6666C7.63398 12.6666 7.33398 12.3666 7.33398 11.9999V8.66659H4.00065C3.63398 8.66659 3.33398 8.36659 3.33398 7.99992C3.33398 7.63325 3.63398 7.33325 4.00065 7.33325H7.33398V3.99992C7.33398 3.63325 7.63398 3.33325 8.00065 3.33325C8.36732 3.33325 8.66732 3.63325 8.66732 3.99992V7.33325H12.0007C12.3673 7.33325 12.6673 7.63325 12.6673 7.99992C12.6673 8.36659 12.3673 8.66659 12.0007 8.66659Z"
                  fill="#FF8D06" />
              </svg>
            </i>
            <span>{{ resource['hrvenue.interviewAddNewCandidate'] }}</span>
          </button>
          <div class="d-flex action-area">
                <button
                  v-if="interviewType === 1 && showScheduleButton"
                  class="border-button-black-detail-information"
                  id="interviewScheduleBtn"
                  :class="[invalid || isValid ? 'disabled' : '']"
                  :disabled="invalid || isValid || buttonLoading"
                  @click="showScheduleModal('schedule')"
                  v-b-tooltip.hover
                  :title="
                    invalid
                      ? resource['label.Enter.RequiredFields']
                      : ''
                  "
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M13.3333 2.00033H12.6666V0.666992H11.3333V2.00033H4.66665V0.666992H3.33331V2.00033H2.66665C1.93331 2.00033 1.33331 2.60033 1.33331 3.33366V14.0003C1.33331 14.7337 1.93331 15.3337 2.66665 15.3337H13.3333C14.0666 15.3337 14.6666 14.7337 14.6666 14.0003V3.33366C14.6666 2.60033 14.0666 2.00033 13.3333 2.00033ZM13.3333 14.0003H2.66665V6.66699H13.3333V14.0003ZM13.3333 5.33366H2.66665V3.33366H13.3333V5.33366Z" fill="#333333"/>
                  </svg>
                  <span>{{ resource['scheduleInterview'] }}</span>
                </button>
                <div v-if="interviewType === 1 && !showScheduleButton" class="schedule-preview">
                  <p>{{ resource['schedulePreview'] }}</p>
                  <button @click="showScheduleModal('schedule')" id="schedule">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M15.8333 3.33366H15V1.66699H13.3333V3.33366H6.66667V1.66699H5V3.33366H4.16667C3.25 3.33366 2.5 4.08366 2.5 5.00033V16.667C2.5 17.5837 3.25 18.3337 4.16667 18.3337H15.8333C16.75 18.3337 17.5 17.5837 17.5 16.667V5.00033C17.5 4.08366 16.75 3.33366 15.8333 3.33366ZM15.8333 16.667H4.16667V8.33366H15.8333V16.667ZM4.16667 6.66699V5.00033H15.8333V6.66699H4.16667ZM5.83333 10.0003H14.1667V11.667H5.83333V10.0003ZM5.83333 13.3337H11.6667V15.0003H5.83333V13.3337Z" fill="#333333"/>
                    </svg>
                    {{ dateRange.startDate && globalFormatTimeUserLocal(dateRange.startDate) }} - {{ dateRange.endDate && globalFormatTimeUserLocal(dateRange.endDate) }}
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M2.49902 17.5011H5.62402L14.8407 8.28444L11.7157 5.15944L2.49902 14.3761V17.5011ZM4.16569 15.0678L11.7157 7.51777L12.4824 8.28444L4.93236 15.8344H4.16569V15.0678Z" fill="#333333"/>
                      <path d="M15.3074 2.74277C14.9824 2.41777 14.4574 2.41777 14.1324 2.74277L12.6074 4.26777L15.7324 7.39277L17.2574 5.86777C17.5824 5.54277 17.5824 5.01777 17.2574 4.69277L15.3074 2.74277Z" fill="#333333"/>
                    </svg>
                  </button>
                </div>
              <div
                v-b-tooltip.hover
                :title="
                  invalid
                    ? resource['label.Enter.RequiredFields']
                    : ''
                "
              >
                <button
                  class="bg-button"
                  id="interviewSaveBtn"
                  :class="[invalid || isValid ? 'disabled' : '']"
                  :disabled="invalid || isValid || buttonLoading"
                  @click="handleSendButtonClick"
                >
                  <i
                    v-if="buttonLoading"
                    class="icon-spinner icon-spin"
                    width="20"
                    height="20"
                  />
                  <span v-if="interviewType === 1">
                    {{ getButtonText }}
                  </span>
                  <span v-else>{{ resource['hrvenue.createCandidateSubmit']}}</span>
                </button>
              </div>
          </div>
      </div>
    </div>
    <step-pagination :step-total="candidate.candidates ? candidate.candidates.length : 0" :step-data-count="pageSize"
    :current-page-index="currentPageIndex" @currentIndex="paginationChanged" />
    <div v-if="showFileUploading"  class="loading-container-detail">
      <div id="loading-detail"></div>
    </div>
    <b-modal v-model="scheduleModal" id="modal-center" centered hide-footer modal-class="schedule-modal" @hide="hideScheduleModal">
      <template slot="modal-header">
        <h3>{{resource['scheduleModalTitle']}}</h3>
        <i class="icon-close custom-modal-close cursor-pointer" @click="hideScheduleModal" />
      </template>
      <div class="d-flex align-items-center justify-content-center flex-column w-100">
        <DateRangePicker ref="dateRangePicker" v-model="dateRange" @update="handleUpdate" :showDateModalError="showDateModalError" :isStartDateFixed="scheduleModalType === 'send'"/>
        <div class="button-area">
          <b-button
            name="cancel"
            class="border-button-detail-information"
            @click="() => {
              hideScheduleModal();
              cancelScheduleModalEvents();
            }"
          >
            <span>{{ resource["feedbackPopupCancel"] }}</span>
          </b-button>
          <b-button
            name="upgrade"
            class="bg-button gap-2 d-flex align-items-center"
            @click="scheduleModalSubmit()"
          >
            <span>{{ scheduleModalType === 'send' ? resource['hrvenue.createCandidateSend'] : "Save"}}</span>
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { read, utils } from 'xlsx';
import { showNotification } from '../../../static/helpers';
import DateRangePicker from '../../DateRangePicker.vue';
import interviewCardItem from './interviewCardItem.vue';

export default {
  name: 'DetailInformation',
  components: {
    interviewCardItem,
    StepPagination: () => import('../../layout/StepPagination.vue'),
    CandidateRemoveWarning: () => import('./CandidateRemoveWarning.vue'),
    DateRangePicker,
  },
  props: {
    candidate: { type: Object, required: true },
    sendableCount: { type: Number, required: true },
    interviewType: { type: Number, required: true, default: 0 },
    invalid: {
      type: Boolean,
      default: false,
    },
    isValid: {
      type: Boolean,
      default: false,
    },
    buttonLoading: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      drag: false,
      file: null,
      pageSize: 20,
      showFileUploading: false,
      currentPageIndex: 1,
      isFileUploaded: false,
      fileName: '',
      fileSize: '',
      notificationShowed: false,
      warningShow: false,
      importedFileCount: false,
      exampleExcellTextPart1: '',
      exampleExcellTextPart2: '',
      scheduleModal: false,
      scheduleModalType: null,
      dateRange: {
        startDate: null,
        endDate: null,
        daysCount: 0,
        startTime: null,
        endTime: null,
      },
      showDateModalError: false,
      showScheduleButton: true,
      showScheduleEditButton: false,
      previousDateRange: {
        startDate: null,
        endDate: null,
        daysCount: 0,
        startTime: null,
        endTime: null,
      },
    };
  },
  created() {
    this.exampleExcellText = this.resource['hrvenue.createcandidate.dowloadLinkText']
      .replace('<b>', '<a href="/files/sampleExcel.xlsx" class="color-purple">')
      .replace('</b>', '</a>');
  },
  computed: {
    isEditable() {
      return true;
    },
    isDelete() {
      return true;
    },
    getCandidates() {
      return this.candidate.candidates ? this.candidate.candidates.slice((this.currentPageIndex - 1) * this.pageSize, this.currentPageIndex * this.pageSize) : [];
    },
    getButtonText() {
      if (this.dateRange.daysCount > 0 && !this.showScheduleButton) {
        return 'Schedule';
      }
      return this.resource['hrvenue.createCandidateSend'];
    },
  },
  methods: {
    validateInputs() {
      const isStartDateValid = !!this.dateRange.startDate;
      const isEndDateValid = !!this.dateRange.endDate;
      const isStartTimeValid = !!this.dateRange.startTime;
      const isEndTimeValid = !!this.dateRange.endTime;

      this.showDateModalError = !(isStartDateValid && isEndDateValid && isStartTimeValid && isEndTimeValid);

      return !this.showDateModalError;
    },
    handleUpdate(value) {
      this.dateRange = value;
    },
    scheduleModalSubmit() {
      if (this.validateInputs()) {
        if (this.scheduleModalType === 'send') {
          this.$emit('checkAction', this.dateRange, this.isSchedule);
          this.dateRange = {
            startDate: null,
            endDate: null,
            daysCount: 0,
            startTime: null,
            endTime: null,
          };
          this.scheduleModal = false;
          this.showScheduleButton = true;
          dataLayer.push({
            event: 'ga4_event',
            event_name: 'popup_click',
            page_type: 'interview-send',
            site_type: 'interview',
            event_parameters: {
              label: 'send-now',
              popup_name: 'interview-scheduling',
            },
          });
        } else {
          this.scheduleModal = false;
          this.showScheduleButton = false;
          this.previousDateRange = { ...this.dateRange };
          this.handleUpdate(this.dateRange);
          dataLayer.push({
            event: 'ga4_event',
            event_name: 'popup_click',
            page_type: 'interview-send',
            site_type: 'interview',
            event_parameters: {
              label: 'save',
              popup_name: 'interview-scheduling',
            },
          });
        }
      }
    },

    showScheduleModal(type) {
      this.scheduleModalType = type;
      const now = new Date();
      dataLayer.push({
        event: 'ga4_event',
        event_name: 'popup_view',
        page_type: 'interview-send',
        site_type: 'interview',
        event_parameters: {
          popup_name: 'interview-scheduling',
        },
      });

      if (type === 'send') {
        dataLayer.push({
          event: 'ga4_event',
          page_type: 'interview-send',
          site_type: 'interview',
          event_name: 'button_click',
          event_parameters: {
            button_name: 'send-now',
          },
        });
        this.isSchedule = false;
        this.dateRange = {
          startDate: now.toISOString(),
          endDate: null,
          daysCount: 0,
          startTime: this.formatTime(now),
          endTime: null,
        };
      } else if (this.dateRange.daysCount > 0 && this.scheduleModalType === 'schedule') {
        dataLayer.push({
          event: 'ga4_event',
          page_type: 'interview-send',
          site_type: 'interview',
          event_name: 'button_click',
          event_parameters: {
            button_name: 'edit',
          },
        });
        this.isSchedule = true;
        this.showScheduleButton = false;
      } else {
        this.showScheduleButton = true;
        dataLayer.push({
          event: 'ga4_event',
          page_type: 'interview-send',
          site_type: 'interview',
          event_name: 'button_click',
          event_parameters: {
            button_name: 'schedule-interview',
          },
        });
      }
      this.scheduleModal = true;
    },

    hideScheduleModal() {
      this.scheduleModal = false;

      if (this.scheduleModalType === 'schedule') {
        if (this.dateRange.daysCount > 0) {
          if (this.previousDateRange.daysCount > 0) {
            this.showScheduleButton = false;
          } else {
            this.showScheduleButton = true;
          }
          // Cancel'a basıldığında önceki değerlere geri dön
          this.dateRange = { ...this.previousDateRange };
        } else {
          // Schedule modunda henüz kayıt yapılmamışsa ve cancel edilirse
          this.showScheduleButton = true;
          this.dateRange = {
            startDate: null,
            endDate: null,
            daysCount: 0,
            startTime: null,
            endTime: null,
          };
        }
      } else if (this.scheduleModalType === 'send') {
        this.showScheduleButton = true;
        this.dateRange = {
          startDate: null,
          endDate: null,
          daysCount: 0,
          startTime: null,
          endTime: null,
        };
      }

      this.scheduleModalType = null;
    },

    cancelScheduleModalEvents() {
      dataLayer.push({
        event: 'ga4_event',
        event_name: 'popup_click',
        page_type: 'interview-send',
        site_type: 'interview',
        event_parameters: {
          label: 'cancel',
          popup_name: 'interview-scheduling',
        },
      });
    },
    paginationChanged(page) {
      this.currentPageIndex = page;

      Array.from(document.querySelectorAll('.interview-input-group'))
        .forEach((el) => {
          const inputs = Array.from(el.querySelectorAll('input'));
          const formGroups = Array.from(el.querySelectorAll('.form-group'));

          formGroups.forEach((inp) => {
            const isEmpty = inputs.every((input) => input.value === '');
            inp.classList.toggle('untouched', isEmpty);
            inp.classList.toggle('touched', !isEmpty);

            if (inp.classList.contains('has-danger')) {
              // inp.querySelector('input').focus();
            }
          });
        });
    },

    cancelRemove() {
      if (this.warningShow) {
        this.warningShow = false;
      }
    },
    checkAction() {
      this.$emit('checkAction');
    },
    // eslint-disable-next-line no-unused-vars
    changed() {
      this.$emit('input', {});
    },
    createNewInterViewer($event, candidateObj) {
      if ($event) {
        this.notificationShowed = false;
        this.$emit('checkAlertShow', false);
        dataLayer.push({
          event: 'ga4_event',
          page_type: 'interview-send',
          site_type: 'interview',
          event_name: 'button_click',
          event_parameters: {
            button_name: 'add-new-candidate',
          },
        });
      }
      if (this.candidate.candidates.length > 7) {
        setTimeout(() => {
          const el = document.querySelector('.card-list-container');
          el.scrollTo({
            top: el.scrollHeight,
            behavior: 'smooth',
          });
        }, 100);
      }
      let activeLength = this.candidate.candidates.length;
      const totalPageCount = activeLength % this.pageSize;
      const lastPage = Math.ceil(activeLength / this.pageSize);
      if (this.candidate.candidates.length < this.sendableCount) {
        if (candidateObj) {
          if (!candidateObj.name && !candidateObj.surname && !candidateObj.email) {
            return;
          }
          const isValid = this.validateFields(candidateObj);
          const newCandidate = { ...candidateObj, isValid };
          const lastChildCandidate = this.candidate.candidates.length - 1;
          const lastChildCandidateName = this.candidate.candidates[lastChildCandidate].name;
          const lastChildCandidateSurname = this.candidate.candidates[lastChildCandidate].surname;
          const lastChildCandidateEmail = this.candidate.candidates[lastChildCandidate].email;
          if (lastChildCandidateName === undefined && lastChildCandidateSurname === undefined && lastChildCandidateEmail === undefined) {
            // this.candidate.candidates[lastChildCandidate] = { ...this.candidate.candidates[lastChildCandidate], ...newCandidate };
            this.candidate.candidates.pop();
            this.candidate.candidates.push(newCandidate);
          } else {
            this.candidate.candidates.push(newCandidate);
            activeLength = this.candidate.candidates.length - 1;
          }
        } else {
          this.candidate.candidates.push({ });
        }
        setTimeout(() => {
          document.querySelectorAll('.interview-input-group').forEach((el) => {
            const formGroups = el.querySelectorAll('.form-group');
            formGroups.forEach((inp) => {
              inp.classList.remove('untouched');
              inp.classList.add('touched');
              if (inp.classList.contains('has-danger')) {
                inp.classList.remove('untouched');
                inp.classList.add('touched');
              }
            });
          });
        }, 100);
        if (totalPageCount === 0) {
          this.currentPageIndex += 1;
        }
        if (this.currentPageIndex < lastPage) {
          this.currentPageIndex = totalPageCount === 0 ? lastPage + 1 : lastPage;
        }
      } else if (!this.notificationShowed) {
        this.notificationShowed = true;
        return showNotification(
          this.resource['Label.Error'],
          this.resource['candidateDetail.candidateNumberExceedError'],
          'error',
        );
      }
    },
    onDeleteQuestion(order) {
      this.candidate.candidates.splice(order + this.pageSize * (this.currentPageIndex - 1), 1);
      if (this.candidate.candidates.length > 7) {
        setTimeout(() => {
          const el = document.querySelector('.card-list-container');
          el.scrollTo({
            top: el.scrollHeight,
            behavior: 'smooth',
          });
        }, 100);
      }
      if (this.candidate.candidates.length % this.pageSize === 0 && this.currentPageIndex !== 1) {
        this.currentPageIndex -= 1;
      }
      this.$emit('onCheckValidRule', this.candidate);
    },
    // eslint-disable-next-line no-unused-vars
    onSelectQuestionDef(candidates, order) {
      this.candidate.candidates.push({ ...candidates });
    },
    removeUploadedFile() {
      this.candidate.candidates = this.candidate.candidates.filter((candidate) => candidate.key !== 'uploaded');
      this.isFileUploaded = false;
      this.notificationShowed = false;
      if (!this.candidate.candidates.length) {
        this.candidate.candidates.push({});
      }
      this.currentPageIndex = 1;
      this.$emit('checkAlertShow', false);
      this.warningShow = false;
      setTimeout(() => {
        Array.from(document.querySelectorAll('.interview-input-group')).forEach((el) => {
          const inputs = el.querySelectorAll('.form-group');

          // eslint-disable-next-line no-restricted-syntax
          for (const inp of inputs) {
            if (inp.classList.contains('has-danger')) {
              inp.classList.remove('untouched');
              inp.classList.add('touched');
            }
            if (inp.querySelector('input').value === '') {
              inp.classList.remove('touched');
              inp.classList.add('untouched');
            }
          }
        });
      }, 20);
    },
    fileUpload(event) {
      this.file = event.target.files ? event.target.files[0] : null;
      if (this.file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = read(data, { type: 'binary' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const rows = utils.sheet_to_json(worksheet, { header: 1, raw: false });
          if (rows[0][0] !== 'Name' || rows[0][1] !== 'Surname' || rows[0][2] !== 'Email') {
            return showNotification(
              this.resource['Label.Error'],
              this.resource['Label.DifferentExcelFileError'],
              'error',
            );
          }
          this.importedFileCount = rows.length - 1;

          rows.slice(1).forEach((row) => {
            const unifiedId = row[3] && row[3].startsWith('æpbæ-') ? row[3].replace('æpbæ-', '') : null;

            const newRow = {
              name: row[0],
              surname: row[1],
              email: row[2],
              unifiedId,
              unifiedIntegrationTypeId: unifiedId ? '825FD80875ADDE0B' : null,
              key: 'uploaded',
            };
            const isValid = this.validateFields(newRow);
            this.createNewInterViewer(null, { ...newRow, isValid });
          });
          setTimeout(() => {
            document.querySelectorAll('.interview-input-group').forEach((el) => {
              const formGroups = el.querySelectorAll('.form-group');
              formGroups.forEach((inp) => {
                inp.classList.remove('untouched');
                inp.classList.add('touched');
                if (inp.classList.contains('has-danger')) {
                  inp.classList.remove('untouched');
                  inp.classList.add('touched');
                }
              });
            });
          }, 100);
          this.isFileUploaded = true;
          this.fileName = this.file.name;
          this.fileSize = Math.floor(this.file.size / 1024);
          const groupedData = this.groupBy();
          let hasErrorItems = [];
          if (groupedData.false) {
            showNotification(
              this.resource['Label.Error'],
              this.resource['Label.GeneralErrorText'], /* Girdiğiniz bilgileri kontrol ediniz. */
              'error',
            );
            hasErrorItems = [...groupedData.false];
            this.currentPageIndex = 1;
          }
          const hasSuccessItems = groupedData.true ? [...groupedData.true] : [];
          if (hasErrorItems.length > 0 || hasSuccessItems.length > 0) {
            this.candidate.candidates = [
              ...this.candidate.candidates.filter((candidate) => (!candidate.key) && (candidate.name || candidate.surname || candidate.email)),
              ...hasErrorItems,
              ...hasSuccessItems,
            ];
          } else {
            this.file = null;
            this.isFileUploaded = false;

            showNotification(
              this.resource['Label.Error'],
              this.resource['Label.EmptyExcelFileError'], // Dosya boş olmamalı,
              'error',
            );
          }
        };
        reader.onloadend = () => {
          this.showFileUploading = false;
        };
        reader.readAsBinaryString(this.file);
        this.showFileUploading = true;
      }
    },
    groupBy() {
      return this.candidate.candidates.reduce((r, a) => {
        r[a.isValid] = r[a.isValid] || [];
        r[a.isValid].push(a);
        return r;
      }, Object.create(null));
    },
    validateFields(obj) {
      if (obj.name === undefined || obj.surname === undefined || obj.email === undefined) {
        obj.name = obj.name !== undefined ? obj.name.slice(0, 75) : obj.name;
        obj.surname = obj.surname !== undefined ? obj.surname.slice(0, 75) : obj.surname;
        return false;
      }
      const nameMatch = obj.name.match(/[a-zA-ZğüşöçıİĞÜŞÖÇ\s]/g);
      const surnameMatch = obj.surname.match(/[a-zA-ZğüşöçıİĞÜŞÖÇ\s]/g);

      obj.name = nameMatch ? nameMatch.join('').slice(0, 75) : '';
      obj.surname = surnameMatch ? surnameMatch.join('').slice(0, 75) : '';
      // eslint-disable-next-line no-useless-escape
      const validEmail = /^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)$/.test(obj.email);
      const validLength = (obj.name.length >= 2 && obj.surname.length >= 2 && obj.email.length >= 10 && obj.email.length <= 300);
      const validName = /^[a-zA-ZğüşöçıİĞÜŞÖÇ\s]*$/.test(obj.name);
      const validSurname = /^[a-zA-ZğüşöçıİĞÜŞÖÇ\s]*$/.test(obj.surname);
      if (validEmail && validLength && validName && validSurname) {
        return true;
      }
      return false;
    },
    onCheckValidRule(obj) {
      this.$emit('onCheckValidRule', obj);
    },
    gtmClickEvent() {
      dataLayer.push({
        event: 'ga4_event',
        event_name: 'upload_excel_click',
        page_type: 'interview-send',
        site_type: 'interview',
      });
    },
    formatTime(date) {
      return date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      }).replace(/^24:/, '00:');
    },
    handleSendButtonClick() {
      if (this.dateRange.daysCount > 0 && !this.showScheduleButton) {
        // Eğer tarih seçilmiş ve schedule modundaysa direkt submit et
        dataLayer.push({
          event: 'ga4_event',
          page_type: 'interview-send',
          site_type: 'interview',
          event_name: 'button_click',
          event_parameters: {
            button_name: 'schedule',
          },
        });
        this.$emit('checkAction', this.dateRange, true);
        this.dateRange = {
          startDate: null,
          endDate: null,
          daysCount: 0,
          startTime: null,
          endTime: null,
        };
        this.showScheduleButton = true;
      } else {
        // Normal send butonu davranışı
        this.showScheduleModal('send');
      }
    },
  },
  watch: {},
};
</script>

<style lang="scss">
@import '~@/style/starter.scss';

.container {
  &:has(.upload) {
    max-width: 100% !important;
    padding: 0 16px !important;
    margin: 0 !important;

    @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
      padding: 0 !important;
    }
  }
}

.custom-modal-one {
  z-index: 4444;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(29, 29, 29, .5);

  &__content {
    width: 400px;
    height: 200px;
    background: #FFFFFF;
    border: 1px solid #E4E4E4;
    border-radius: 8px;
    position: absolute;
    left: calc(50% - 200px);
    top: calc(50% - 100px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__title{
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #1D1D1D;
  }
}
.card-list-container {
  height: calc(100vh - 527px);
  overflow-y: auto;
  min-height: 200px !important;
}
.list-group{
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.separate {
  margin: 16px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #595959;
  opacity: 0.8;
}
.total-items{
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #353535;
}

.upload {
  background: #FFFFFF;
  border: 1px solid #E4E4E4;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
    margin-top: 16px;
  }

  &__content {
    display: flex;
    justify-content: space-between;
    padding:16px;

    @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
      flex-direction: column;
    }

    &_left{
      width: 80%;

      @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
        width: 100%;
      }

      &-title{
        font-weight: 700;
        font-size: 20px;
        line-height: 26px;
        color: #353535;
      }
      &-instruction{
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
        color: #595959;
        opacity: 0.8;
        margin:8px 0;
      }
      &-example_file{
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        color: #595959;
        opacity: 0.8;
        .color-purple{
          font-size: 12px !important;
          line-height: 18px !important;
          color:#FF8D06 !important;
          font-weight: 700 !important;
          cursor: pointer;
        }
      }
    }
    &_right {
      width: 20%;

      @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
        width: 100%;
      }

      .result-container{
        flex:1;
      }
      &-action{
        display: flex;
        justify-content: flex-end;
      }
      &-result{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        height: 100%;
        border: 1px solid #E4E4E4;
        border-radius: 4px;
        padding: 0 8px;
        &-icon{
          display: flex;
        }
        &-info{
          display: flex;
          flex-direction: column;
          flex:1;
          margin-left:4px;
        }
      }
    }
    &_file--name{
      font-weight: 700;
      font-size: 14px;
      line-height: 18px;
      color: #353535;
      max-width: 154px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &_file--size{
      width: 100%;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      color: #595959;
      opacity: 0.8;
    }
  }
}

.has-search .form-control {
  padding-left: 2.375rem;
}

.fw-500 {
  font-weight: 500 !important;
}

.has-search .form-control-feedback {
  position: absolute;
  z-index: 2;
  display: block;
  width: 2.375rem;
  height: 2.375rem;
  line-height: 2.375rem;
  text-align: center;
  pointer-events: none;
  color: #aaa;
  font-size: x-large;
}

.checkout-size {
  width: 20px;
  height: 20px;
}

.checkout-td-size {
  width: 20px;
}

.borderless table {
  border-top-style: none;
  border-left-style: none;
  border-right-style: none;
  border-bottom-style: none;
}

table {
  display: block;
}

.loading-container-detail{
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  right: 0;
  border: 0;
  top: 0;
  height: 100vh !important;
  background: rgba(255, 255, 255, 0.8);
  z-index: 4444;
}
#loading-detail {
  display: inline-block;
  width: 50px;
  height: 50px;
  border: 3px solid #e6e6e6;
  border-radius: 50%;
  border-top-color: #FF8D06;
  animation: spin 1s cubic-bezier(0.46, 0.03, 0.52, 0.96) infinite;
  -webkit-animation:spin 1s cubic-bezier(0.46, 0.03, 0.52, 0.96) infinite;
}

@keyframes spin {
  to { -webkit-transform: rotate(360deg); }
}
@-webkit-keyframes spin {
  to { -webkit-transform: rotate(360deg); }
}

.border-button-detail-information {
  display: flex;
  padding: 9px 16px;
  justify-content: center;
  align-items: center;
  border-radius: 114px;
  border: 1px solid #ff8d06;
  background: transparent !important;
  transition: all 0.2s ease-in-out;
  color: var(--main-colors-orange, #ff8d06);
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;

  @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
    width: 100%;
    margin-top: 16px;
  }

  i {
    margin-right: 0px !important;
  }

  span {
    padding: 0 8px;
  }

  &:hover {
    background: #ff8d06 !important;

    span {
      color: #fff !important;
    }
    svg {
      path {
        fill: #fff !important;
      }
    }
  }
}

.border-button-black-detail-information {
  display: flex;
  padding: 6px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 40px;
  border: 1px solid #D4D4D4;
  transition: all 0.2s ease-in-out;

  @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
    flex: 1;
  }

  span {
    color: #333;
    text-align: center;
    font-feature-settings: 'liga' off, 'clig' off;
    /* Typography/Button & Link/2(Button Label) - Bold */
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
    padding: 0 8px;
  }

  &:hover {
    background: #E5E5E5;
  }

  &.disabled {
    span {
      color: #fff !important;
    }

    svg {
      path {
        fill: #fff !important;
      }
    }
  }
}

.bg-button {
  display: flex;
  padding: 6px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 114px;
  border: 1px solid #ff8d06;
  background: #ff8d06;
  transition: all 0.2s ease-in-out;

  span {
    color: #fff;
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
    padding: 0 8px;
  }

  &.disabled {
    border-color: transparent;
  }

  &:hover {
    background: #FF7415 !important;
  }
}

.action-area {
  width: fit-content;
  display: flex;
  gap: 8px;
  justify-content: flex-end;

  @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
    width: 100%;
  }
}

.schedule-modal {
  .button-area {
    display: flex;
    width: 100%;
    gap: 8px;
    margin-top: 24px;
    justify-content: flex-end;
  }
  .modal-dialog {
    max-width: 564px;
  }
  .modal-content {
    border-radius: 12px;
  }

  .modal-header {
    border-bottom: 0;
    padding: 16px 16px 16px 32px;
    border-bottom: 1px solid var(--Background-Colors-Secondary-Gray, #E5E5E5);

    i {
      font-size: 24px;
      color: #333333;
    }
  }

  .modal-body {
    border-bottom: 0;
    padding: 24px 32px 16px 32px;

    img {
      margin-bottom: 14px;
    }

    h2 {
      color: #353535;
      text-align: center;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Roboto;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 26px;
      margin-bottom: 8px;
    }

    p {
      color: #858585;
      text-align: center;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Roboto;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      margin-bottom: 24px;
    }
  }
}

.schedule-preview {
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;

  p {
    color: var(--Text-Colors-Primary-Gray-Text, #333);
    font-feature-settings: 'liga' off, 'clig' off;
    /* Typography/Subtitle/3 - Medium */
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
  }

  button {
    display: flex;
    padding: var(--Padding-Regular, 8px);
    align-items: center;
    justify-content: center;
    gap: var(--Padding-Small, 4px);
    border-radius: 4px;
    border: 1px solid var(--Stroke-Colors-Tertiary-Gray-Stroke, #C3C3C3);
    background: var(--Background-Colors-White, #FFF);

    color: var(--Text-Colors-Primary-Gray-Text, #333);
    font-feature-settings: 'liga' off, 'clig' off;
    text-overflow: ellipsis;
    /* Typography/Body/3 - Regular */
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
}

.unified-content {
  background: #FFFFFF;
  border: 1px solid #E4E4E4;
  border-radius: 4px;
  margin-top: 16px;
}

.candidate-action-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;

  @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
    flex-direction: column;
    gap: 16px;
  }
}
</style>
